import type { TFontWeightsValid, TFontWeightValid, TLineHeights } from '../models';

export const LINE_HEIGHTS: TLineHeights = [
    16, 18, 20, 22, 24, 26, 28, 32, 36, 40, 48, 52, 64,
] as const;
export const FONT_WEIGHTS_VALID: TFontWeightsValid = [300, 400, 500, 600, 700] as const;

export const fontWeightsMap: Record<number, TFontWeightValid> = {
    3: 300,
    4: 400,
    5: 500,
    6: 600,
    7: 700,
};

// Совпадает с дефолтом в файле styles.css
export const defaultFontSize = 16;
export const defaultLineHeight = 1.4 as const;
export const DEFAULT_FONT_WEIGHT = 400;
export const defaultTheme = 'light';

export { fontPresets } from './font-presets';
export { fontViewsDesktop, fontViewsMobile } from './font-views';
